import { Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Extrafields } from '../Interface/Extrafields';
import { RestService } from './rest-service';
import { Extraperson } from '../Interface/Extraperson';
import { States } from '../Interface/States';
import { Country } from '../Interface/Country';
import { City } from '../Interface/City';

@Injectable({
  providedIn: 'root'
})
export class ExtraFieldsService  extends RestService{
  endpoint = `${environment.api}`;

  // Signals for extra field refresh
  private _refreshExtraField = signal(0);
  get refreshExtraField() {
    return this._refreshExtraField;
  }

  private _refreshExtraDependentField = signal(0);
  get refreshExtraDependentField() {
    return this._refreshExtraDependentField;
  }
  
  extraFieldCreate(formData: object) {
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/extra-field-create/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraField.update(count => count + 1);
      })
    );
  }

  
  
  extraFieldUpdate(formData: object) {
    return this.http.put<Extrafields>(
      `${this.endpoint}extra-fields/extra-field-update/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraField.update(count => count + 1);
      })
    );
  }
  
  extraFieldSaveOrder(formData: object) {
    return this.http.put<Extrafields>(
      `${this.endpoint}extra-fields/extra-field-save-order/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraField.update(count => count + 1);
      })
    );
  }
  
  extraFieldSaveMakeHidden(formData: object) {
    return this.http.put<Extrafields>(
      `${this.endpoint}extra-fields/extra-field-make-hidden/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraField.update(count => count + 1);
      })
    );
  }

  reviewFieldsShowHide(formData: object) {
    return this.http.put<Extrafields>(
      `${this.endpoint}extra-fields/review-field-show-hide/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraField.update(count => count + 1);
      })
    );
  }
  
  extraFieldList(formData: object, page:number, pageSize:number) {
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/extra-field-list/?page=${page}&&page_size=${pageSize}`,
      formData
    );
  }
  
  getExtraPersonSetting(formData: object) {
    return this.http.post<Extraperson>(
      `${this.endpoint}extra-person/get-extra-person-setting/`,
      formData
    );
  }
  
  
  allSignupFieldList(formData:object){
    return this.http
      .post<Extrafields>(`${this.endpoint}extra-fields/get-all-signup-field-from-admin-side/`, formData);
  }
  
  insertSignupCompleted(formData:object){
    return this.http
      .post<Extrafields>(`${this.endpoint}client/sign-up-complete/insert-all-data-for-sign-up/`, formData);
  }
  
  updateSignupCompleted(formData:object){
    return this.http
      .put<Extrafields>(`${this.endpoint}extra-fields/update-signup-data-from-admin-side/`, formData);
  }
  
  
  
  getStateList(formData: object) {
    return this.http.post<States>(
      `${this.endpoint}client/extra-fields/get-state-list/`,
      formData
    );
  }
  
  getCityList(formData: object) {
    return this.http.post<City>(
      `${this.endpoint}client/extra-fields/get-city-list/`,
      formData
    );
  }
  
  getCountryList(formData: object) {
    return this.http.post<Country>(
      `${this.endpoint}client/extra-fields/get-country-list/`,
      formData
    );
  }

  dropdownTopicDependentFieldList(formData: object, page:number, pageSize:number) {
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/dropdown-topic-dependent-field-list/?page=${page}&&page_size=${pageSize}`,
      formData
    );
  }

  dropdownTopicDependentFieldValueList(field_master_id: number, field_type:number, event_id:number) {
    const formData = {
      "field_master_id": field_master_id,
      "event_id": event_id,
      "field_type": field_type,
    }
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/dependent-field-value-list/?page=1&&page_size=100`,
      formData
    );
  }

  destinationFieldList(source_field_id: number, field_for:number, event_id:number) {
    const formData = {
      "source_field_id": source_field_id,
      "event_id": event_id,
      "field_for": field_for,
    }
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/destination-field-list/?page=1&&page_size=100`,
      formData
    );
  }

  dependentFieldCreate(formData: object) {
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/dependent-field-create/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraDependentField.update(count => count + 1);
      })
    );
  }
  dependentFieldAllList(formData: object, page: number, pageSize: number) {
    return this.http.post<Extrafields>(
      `${this.endpoint}extra-fields/dependent-field-all-list/?page=${page}&&page_size=${pageSize}`,
      formData
    );
  }

  dependentFieldDelete(formData: object) {
    return this.http.put<Extrafields>(
      `${this.endpoint}extra-fields/dependent-field-delete/`,
      formData
    ).pipe(
      tap((data) => {
        this._refreshExtraDependentField.update(count => count + 1);
      })
    );
  }

}
